import { Injectable, inject } from '@angular/core';
import { HdContentLanguageService } from '../hd-content-language.service';

/**
 * Onderwerpen uit het relatieboek ("Human Design Relaties") die als
 * markdown-paneel opengaan. De thema-topics volgen de composite-theme-keys
 * ('5'..'9' = aantal samen gedefinieerde centers); de kanaalblok-topics volgen
 * de blok-keys van hd-composite-sections.
 */
export type HdRelationInfoTopic =
  | 'general'
  | 'type'
  | 'profile'
  | 'nodes'
  | 'centers'
  | 'theme-5'
  | 'theme-6'
  | 'theme-7'
  | 'theme-8'
  | 'theme-9'
  | 'electromagnetics'
  | 'compromises'
  | 'dominances'
  | 'companionships';

const HD_RELATIONS_ASSET_BASE = '/assets/docs/human-design/relations';
const HD_RELATION_MARKDOWN_LANGUAGES = new Set(['nl', 'en']);

/** Kanaalblok-topics krijgen een `channel-`-prefix in de bestandsnaam. */
const HD_RELATION_CHANNEL_TOPICS: ReadonlySet<HdRelationInfoTopic> = new Set([
  'electromagnetics',
  'compromises',
  'dominances',
  'companionships',
]);

@Injectable({ providedIn: 'root' })
export class HdRelationInfoService {
  private readonly contentLanguage = inject(HdContentLanguageService);

  relationMarkdownUrl(topic: HdRelationInfoTopic, lang?: string): string {
    const fileName = HD_RELATION_CHANNEL_TOPICS.has(topic) ? `channel-${topic}` : topic;
    return `${HD_RELATIONS_ASSET_BASE}/${this.resolveMarkdownLanguage(lang)}/${fileName}.md`;
  }

  private resolveMarkdownLanguage(lang?: string): string {
    const requestedLanguage = lang ?? this.contentLanguage.effectiveLang();
    const normalizedLanguage = (requestedLanguage || '').toLowerCase().split('-')[0];
    return HD_RELATION_MARKDOWN_LANGUAGES.has(normalizedLanguage) ? normalizedLanguage : 'nl';
  }
}
